import { AppService } from './../../../../core/app.service';
import { Component, OnInit } from '@angular/core';
import { TableRegroupementExpressionBesoin } from '../../../../data/schemas/table.schema';
import { routeAlias } from '../../../../../routesalias';
import { UiTable } from "../../../../components/ui/table/table.component";
import { RouterLink } from '@angular/router';
import { ExpressionBesoinRes } from '../../../../data/http/responses/expression.res';
import { ExpressionBesoinService } from '../../../../services/expressionbesoin.service';

@Component({
  selector: 'app-regroupementbesoin',
  imports: [],
  templateUrl: './regroupementbesoin.component.html',
  styleUrl: './regroupementbesoin.component.css'
})
export class RegroupementbesoinPage implements OnInit {
  public tableRegroupementExpressionBesoin = TableRegroupementExpressionBesoin
  public routealias = routeAlias;
  public expressionBesoins: ExpressionBesoinRes[] = []

  constructor(
    private AppService: AppService,
    private expressionBesoinService: ExpressionBesoinService,
  ) { }

  ngOnInit(): void {
    this.loadExpressionBesoins()
  }

  loadExpressionBesoins(): void {
    this.expressionBesoinService.getAllByAppIdExcludeRegroupement(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        //console.log(response.data)
        this.expressionBesoins = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }
}
